export const TELEGRAM = 'https://t.me/MojitoFinance'
export const TWITTER = 'https://twitter.com/MojitoSwap'
export const MEDIUM = 'https://medium.com/@mojitoswap'
export const GITHUB = 'https://github.com/MojitoFinance'
export const DOCS = 'https://docs.mojitoswap.finance'

